export default class Timeline {
	el: any;
	offset: number;
	children = [];
	windowH: number;
	offsetTop: {};

	constructor(el: any, offset: number) {
		this.el = el;
		this.offset = offset;
		this.children = this.el.children;

		this.windowH = window.innerHeight
						|| document.documentElement.clientHeight
						|| document.body.clientHeight;

		this.offsetTop = this.getOffset(this.el).top;

		this.hideBlock();
		this.setOffsets();
		this.watch();
	}

	showBlock() {
		for (const child of this.children) {
			if (this.offsetTop <= window.scrollY + this.windowH * this.offset) {
				child.classList.remove('is-hidden');
			}
		}
	}

	hideBlock() {
		for (const child of this.children) {
			if (this.offsetTop > window.scrollY + this.windowH * this.offset) {
				child.classList.add('is-hidden');
			}
		}
	}

	setOffsets() {
		const elH = this.el.clientHeight;
		const nextEl = this.el.nextElementSibling;

		if (nextEl) {

			if (window.innerWidth > 766) {
				nextEl.style.marginTop = `-5rem`;
			} else {
				nextEl.style.marginTop = `1rem`;
			}


		}
	}

	getOffset(el) {
	    let rect = el.getBoundingClientRect();
	    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	    return { top: rect.top + scrollTop }
	}

	watch() {

		window.addEventListener('scroll', () => {

			if (!window.requestAnimationFrame) {
				setTimeout(() => {
					this.showBlock();
					this.hideBlock();
				}, 100);
			}
			else {
				window.requestAnimationFrame(() => {
					this.showBlock();
					this.hideBlock();
				});
			}

		});
	}
}